import { Icon } from './icons';
import type { ReactNode } from 'react';
import { CollectionSelectionItem } from './collection-scaffold';

export interface BulkEditorRailItem {
  id: string;
  icon: 'projects' | 'leads' | 'customers' | 'tasks' | 'resources' | 'contracts' | 'invoices';
  label: string;
  subtitle?: string | null;
}

export function BulkEditorRail({
  title,
  items,
  hiddenSelectedCount = 0,
  onClose,
  onRemoveItem,
  destructiveAction,
  primaryAction,
  secondaryAction,
  children
}: {
  title: string;
  items: BulkEditorRailItem[];
  hiddenSelectedCount?: number;
  onClose: () => void;
  onRemoveItem: (id: string) => void;
  destructiveAction?: { label: string; onClick: () => void } | undefined;
  primaryAction?: { label: string; onClick: () => void; disabled?: boolean } | undefined;
  secondaryAction?: { label: string; onClick: () => void } | undefined;
  children?: ReactNode;
}): JSX.Element {
  return (
    <aside className="av-bulk-editor-rail">
      <div className="av-bulk-editor-rail__header">
        <div>
          <h2>{title}</h2>
          {hiddenSelectedCount > 0 ? <p>{hiddenSelectedCount} ascunse de filtrele active</p> : null}
        </div>
        <button aria-label={title} className="av-bulk-editor-rail__close" type="button" onClick={onClose}>
          <Icon name="times" />
        </button>
      </div>

      {destructiveAction ? (
        <div className="av-bulk-editor-rail__danger">
          <button className="av-danger-button" type="button" onClick={destructiveAction.onClick}>
            {destructiveAction.label}
          </button>
        </div>
      ) : null}

      <div className="av-bulk-editor-rail__items">
        {items.map((item) => (
          <CollectionSelectionItem
            key={item.id}
            icon={item.icon}
            label={item.label}
            subtitle={item.subtitle}
            onRemove={() => onRemoveItem(item.id)}
          />
        ))}
      </div>

      {children ? <div className="av-bulk-editor-rail__content">{children}</div> : null}

      {primaryAction || secondaryAction ? (
        <div className="av-bulk-editor-rail__footer">
          {secondaryAction ? (
            <button className="av-secondary-button" type="button" onClick={secondaryAction.onClick}>
              {secondaryAction.label}
            </button>
          ) : null}
          {primaryAction ? (
            <button className="av-primary-button" disabled={primaryAction.disabled} type="button" onClick={primaryAction.onClick}>
              {primaryAction.label}
            </button>
          ) : null}
        </div>
      ) : null}
    </aside>
  );
}
